module.exports = __webpack_public_path__ + "img/21.052ec4f2.svg";